import { ReactComponent as FilterIcon } from "../../../assets/images/icon-filter.svg";
import React from 'react';
import { useTranslation } from 'react-i18next';

import Styles from "../../../scss/orderHistory.module.scss";

interface IOrderListFilterIconProps {
    isLoading: boolean;
    openFiltersDialog: () => void;
    selectedFilterCount: number;
}

export function OrderListFilterIcon({
    isLoading,
    openFiltersDialog,
    selectedFilterCount
}: IOrderListFilterIconProps) {
    const { t } = useTranslation();

    return <div onClick={() => { if (!isLoading) openFiltersDialog() }}
        className={`${selectedFilterCount > 0 ? Styles.aplliedFilters : undefined} ${Styles.filterBtn}`}>
        <FilterIcon />
        <p>{t("orderHistory.filters.button")} {selectedFilterCount > 0 && <span>({selectedFilterCount})</span>}</p>
    </div>
}